import {Directive, Input, Renderer2, TemplateRef, ViewContainerRef} from '@angular/core';

import {ModalService} from './modal.service';

@Directive({
  selector: '[gp-modal-struct]'
})
export class ModalStructuralDirective {

  @Input('gp-modal-struct')
  public modalId: string;

  constructor(private modalService: ModalService,
              private renderer: Renderer2,
              private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef) {
    modalService.modalOpened.subscribe((id: string) => {
      if (id === this.modalId) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.renderer.addClass(document.body, 'modal-open');
      }
    });

    modalService.modalClosed.subscribe((id: string) => {
      if (id === this.modalId && !this.modalService.modalWithIdOpen.length) {
        this.viewContainer.clear();
        this.renderer.removeClass(document.body, 'modal-open');
      }
    });
  }
}
